var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c("el-input", {
        staticStyle: { cursor: "pointer" },
        attrs: { readonly: "", placeholder: _vm.placeholder, "read-only": "" },
        nativeOn: {
          click: function ($event) {
            return _vm.showPicker.apply(null, arguments)
          },
        },
        model: {
          value: _vm.showValue,
          callback: function ($$v) {
            _vm.showValue = $$v
          },
          expression: "showValue",
        },
      }),
      _c(
        "el-row",
        { staticStyle: { "margin-top": "1em" } },
        [
          _vm.item.config.requireDetailAddr
            ? _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 2,
                  placeholder: "请输入详细地址",
                },
                on: { change: _vm.changeHandle },
                model: {
                  value: _vm.detailAddr,
                  callback: function ($$v) {
                    _vm.detailAddr = $$v
                  },
                  expression: "detailAddr",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "van-popup",
        {
          attrs: { round: "", position: "bottom" },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _c("van-cascader", {
            attrs: {
              options: _vm.options,
              title: "点击选择所在地区",
              "field-names": _vm.fieldNames,
            },
            on: {
              close: function ($event) {
                _vm.visible = false
              },
              finish: _vm.handleConfirm,
            },
            model: {
              value: _vm.popupCascaderValue,
              callback: function ($$v) {
                _vm.popupCascaderValue = $$v
              },
              expression: "popupCascaderValue",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }